import { useState, SetStateAction } from "react";
import { Asset } from "../../../models/asset";
import Card from "./card";
import { Scheduling } from "../../../models/schedule";
import { SignedRevision } from "../../../models/signedRevision";

interface IOilChangeProps {
  asset: Asset | null;
  blockchainData: (scheduleId: string) => SignedRevision | undefined;
  loading: boolean;
}

const OilChange = ({ asset, blockchainData, loading }: IOilChangeProps) => {
  const [order, setOrder] = useState<string>("down");
  const handleOrderChange = () => setOrder(order === "down" ? "up" : "down");
  const [activeTab, setActiveTab] = useState("tab1");

  const handleTabClick = (tab: SetStateAction<string>) => {
    setActiveTab(tab);
  };

  return (
    <div className="oil-change-content">
      <div className="flex justify-between items-center actions-row">
        <button type="button" className="btn btn-default btn-icon-only">
          <span className="rioglyph rioglyph-tachograph-download"></span>
        </button>
        <div className="form-group">
          <div className="display-flex gap-10 align-items-end">
            <div className="form-group">
              <button
                type="button"
                className="btn btn-default"
                onClick={handleOrderChange}
              >
                Por ordem
                <span
                  className={`rioglyph rioglyph-chevron-${order} padding-left-10`}
                  aria-hidden="true"
                />
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="flex justify-center margin-top-20 margin-bottom-20 alert-tabs">
        <button
          className={`p-4 w-1/2 ${
            activeTab === "tab1" ? "active-tab" : "text-gray-500"
          }`}
          onClick={() => handleTabClick("tab1")}
        >
          Próximas
        </button>
        <button
          className={`p-4 w-1/2 ${
            activeTab === "tab2" ? "active-tab" : "text-gray-500"
          }`}
          onClick={() => handleTabClick("tab2")}
        >
          Realizadas
        </button>
        {/* <button
          className={`p-4 w-1/3 ${
            activeTab === "tab3" ? "active-tab" : "text-gray-500"
          }`}
          onClick={() => handleTabClick("tab3")}
        >
          Vencidas
        </button> */}
      </div>

      {!loading && activeTab === "tab1" && (
        <>
          <h3 className="text-normal text-size-16 margin-bottom-10">
            Próximas trocas
          </h3>
          <div className="grid grid-cols-2 gap-6 scrollable">
            {[].map((scheduleCheckup: Scheduling) => (
                <Card scheduling={scheduleCheckup} isOilChange={true} isSigned={!!blockchainData(scheduleCheckup.id)?.id} />
              ))}
          </div>
        </>
      )}

      {!loading && activeTab === "tab2" && (
        <>
          <h3 className="text-normal text-size-16 margin-bottom-10">
            Trocas realizadas
          </h3>
          <div className="grid grid-cols-2 gap-6 scrollable">
            {[].map((scheduleCheckup: Scheduling) => (
                <Card scheduling={scheduleCheckup} isOilChange={true} isSigned={!!blockchainData(scheduleCheckup.id)?.id} />
              ))}
          </div>
        </>
      )}

      {/* {!loading && activeTab === "tab3" && (
        <>
          <h3 className="text-normal text-size-16 margin-bottom-10">
            Trocas vencidas
          </h3>
        </>
      )} */}
    </div>
  );
};

export default OilChange;
